/* SWINDLE KING — size guide / modal controller (scoped, no deps) */
(function () {
  'use strict';
  function closeDlg(d) { if (typeof d.close === 'function') { d.close(); } else { d.removeAttribute('open'); } }
  function init() {
    document.querySelectorAll('[data-skc-modal-open]:not([data-skc-init])').forEach(function (btn) {
      btn.setAttribute('data-skc-init', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var d = document.getElementById(btn.getAttribute('data-skc-modal-open'));
        if (!d) return;
        if (typeof d.showModal === 'function') { d.showModal(); } else { d.setAttribute('open', ''); }
      });
    });
    document.querySelectorAll('dialog.skc-modal:not([data-skc-init])').forEach(function (d) {
      d.setAttribute('data-skc-init', '1');
      d.querySelectorAll('[data-skc-modal-close]').forEach(function (x) {
        x.addEventListener('click', function () { closeDlg(d); });
      });
      d.addEventListener('click', function (e) { if (e.target === d) closeDlg(d); });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
